//@flow
import FunctionStore from '../Base/functionStoreClass';
import { apiUpdateState, applyServerDefaultData, reset } from '../Base/storeUtils';
import Constants from '../../constants';
import MembershipModel from './membershipModel';
import APIInterface from '../../APIInterfaces/membership';
import MembershipPlanModel from './membershipPlanModel';
import { toImmutable } from '../../Utils/immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';
import type { CustomerObject } from '../Customer/customerModel';
import type { MembershipObject } from './membershipModel';

const NO_MEMBERSHIP_PLAN = new MembershipPlanModel();

export default class MembershipStore extends FunctionStore {
  getMembership():MembershipModel {
    return this._resolvePropertyObject('membership', MembershipModel);
  }

  getMembershipPlan(planCode?:string):MembershipPlanModel {
    const membership = this.getMembership();

    planCode = membership.getPlanCode() || planCode;
    if (!planCode) return NO_MEMBERSHIP_PLAN;
    return this._getMembershipPlanByCode(planCode);
  }

  _getMembershipPlanByCode(planCode:string) {
    const loadFunc = APIInterface.getMembershipPlans;
    return this._resolvePropertyObject(['membershipPlans', planCode], MembershipPlanModel, loadFunc);
  }

  _initialState(state:StoreState) {
    applyServerDefaultData('membershipPlansData', state, _responseToGetMembershipPlansSuccess);
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.GET_CUSTOMER_SUCCESS, apiUpdateState(_responseToGetCustomerSuccess));
    onSuccess(Constants.LOGOUT, reset);
    onSuccess(Constants.ADD_CREDIT_CARD_SUCCESS, APIInterface.getMembership);
    onSuccess(Constants.GET_MEMBERSHIP, APIInterface.getMembership);
    onSuccess(Constants.GET_MEMBERSHIP_SUCCESS, apiUpdateState(_responseToGetMembershipSuccess));
    onSuccess(Constants.UPDATE_MEMBERSHIP_SUCCESS, apiUpdateState(_responseToGetMembershipSuccess));
    onSuccess(Constants.CREATE_MEMBERSHIP_SUCCESS, apiUpdateState(_responseToGetMembershipSuccess));
    onSuccess(Constants.CANCEL_MEMBERSHIP_SUCCESS, apiUpdateState(_responseToGetMembershipSuccess));
    onSuccess(Constants.GET_MEMBERSHIP_PLANS_SUCCESS, apiUpdateState(_responseToGetMembershipPlansSuccess));

    onError(Constants.NOT_AUTHORIZED, reset);
  }
}

function _responseToGetCustomerSuccess(state:StoreState, data:CustomerObject) {
  const membership = data && data.membership;
  if (membership) _responseToGetMembershipSuccess(state, membership);
}

//If the membership is cancelled, don't use that membership info
function _responseToGetMembershipSuccess(state:StoreState, data:MembershipObject) {
  const membership = data.status !== 'canceled' ? data : {};
  state.set('membership', toImmutable(membership));
}

//Set newMemberPlan
function _responseToGetMembershipPlansSuccess(state:StoreState, data:Object) {
  state.set('membershipPlans', toImmutable(data));
}
